export const API_URL = "https://ams-puzzel-wallboard.azurewebsites.net";


export const HOME_URL = "/";
export const WALLBOARDS_URL = "/wallboards";